import Button from '@ui/components/Button/Button';
import FontAwesomeProIcon from '@ui/components/FontAwesomeProIcon/FontAwesomeProIcon';
import classNames from 'classnames';
import React from 'react';

// make sure to use data-no-slide attribute on direct child component of Slider so that Swiper.js correctly interprets it
const SliderControl = ({ direction, className, ...props }) => (
  <Button
    aria-label={direction === 'right' ? 'Weiter' : 'Zurück'}
    className={classNames(
      `${direction === 'right' ? 'next-button' : 'prev-button'}`,
      className,
    )}
    isElevated
    shape="bubble"
    theme="secondary"
    {...props}
  >
    <FontAwesomeProIcon
      icon={direction === 'right' ? 'chevron-right' : 'chevron-left'}
    />
  </Button>
);

export default SliderControl;
